export const inCashOptions = ['boleto', 'pix'];

export const getMainCashbackText = cashbacks => {
  const formatedCashbacks = cashbacks ?? [];
  let cashbackText = formatedCashbacks[0];
  if (formatedCashbacks.length > 1) {
    cashbackText = formatedCashbacks.filter(text => !text.includes('parcelado'))[0];
  }

  return cashbackText;
};

export const getPaymentDisplay = type => {
  switch (type) {
    case 'cartaoMarca':
      return '.';
    default:
      return ' no cartão de crédito.';
  }
};

export const getPaymentInstallmentText = (mainPayment, hasCashbackText) => {
  const { type, hasInCashDiscount, paymentInstallmentText, paymentConditionText } = mainPayment;
  let showInstallmentText = !paymentConditionText && paymentInstallmentText;
  if (inCashOptions.includes(type)) {
    showInstallmentText = true;
  } else if (hasInCashDiscount) {
    showInstallmentText = !hasCashbackText;
  }

  return showInstallmentText ? fmtPaymentInstallmentText(type, hasInCashDiscount, paymentInstallmentText) : null;
};

export const fmtPaymentInstallmentText = (type, hasInCashDiscount, installmentText) => {
  const prefix = !hasInCashDiscount && !inCashOptions.includes(type) ? 'em ' : '';
  const suffix = `${getPaymentDisplay(type)}`;

  return `${prefix}${installmentText}${suffix}`;
};
